import { api } from './_init'
import { LOADING, UPDATE, FAIL } from '../reducers/default'
import { returnErrorMessage } from 'utils/helpers'

export const fetchPartnerDetails = async (dispatch, { rethrow = false } = {}) => {
  dispatch({ type: LOADING })
  try {
    const result = await api.get('/partners/')
    if (result.status === 200) {
      localStorage.setItem(
        'partnerDetails',
        JSON.stringify({
          clientId: result.data.id,
          name: result.data.name,
          domain: result.data.domain,
          campaignRecommendationsModel: result.data.campaign_recommendations,
          demandPredictionModel: result.data.demand_prediction,
          vertical: result.data.vertical,
          attributionModel: result.data.attribution_model_default,
          product: result.data.product?.split('.')[1],
        }),
      )
      if (result.data.currency) localStorage.setItem('userCurrency', result.data.currency)
      if (result.data.attribution_model_default) {
        localStorage.setItem('attributionModel', result.data.attribution_model_default?.split('.')[1])
      }
    }
    dispatch({ type: UPDATE, payload: result.data })
  } catch (error) {
    dispatch({ type: FAIL })
    // Login (Cognito/hooks.js) swallows this by design; useAccountSwitcher.js
    // opts into rethrow to roll back the switch instead.
    if (rethrow) throw error
  }
}

export const updateAttributionModel = async (dispatch, attributionModel) => {
  dispatch({ type: LOADING })
  try {
    const result = await api.put(`/partners/attribution_model?model=${attributionModel}`)
    if (result.status === 204) {
      localStorage.setItem('attributionModel', attributionModel)
      dispatch({ type: UPDATE, payload: { attributionModel } })
    } else {
      dispatch({ type: FAIL, payload: returnErrorMessage({ result })})
    }
  } catch (error) {
    dispatch({ type: FAIL })
  }
}

// Client-global Google Ads branding defaults (business name + logo), used
// as a fallback wherever a creative doesn't set its own — see PD-3388-04-17.
export const fetchPartnerBranding = async () => {
  const result = await api.get('/partners/')
  return {
    businessName: result.data.business_name || '',
    logoUrl: result.data.logo_url || '',
  }
}

export const updatePartnerBranding = async ({ businessName, logoUrl }) => {
  const result = await api.put('/partners/branding', {
    business_name: businessName,
    logo_url: logoUrl,
  })
  return {
    businessName: result.data.business_name,
    logoUrl: result.data.logo_url,
  }
}
